import ApiGet from "../../../../../api-controller-mod/api-serv/get-api/getApi";
import ApiPatch from "../../../../../api-controller-mod/api-serv/post-api/patchApi";
import { MockSetGroup } from "../../../../../component-controller-mod/component-serv/list-fs-cp/media-list-op/ts/setting-list-tier.type";

export const MockSetApplication: MockSetGroup[] = [
  {
    id: 1,
    title: "Job Administration",
    description: "Manage job posting settings and configurations",
    items: [
      {
        id: 1,
        title: "Job approval required",
        description: "Require admin approval before job postings go live",
        controlType: "toggle"
      },
      {
        id: 2,
        title: "Auto-unpublish on expiry",
        description: "Number of days before job posting expires",
        controlType: "toggle"
      },
      {
        id: 3,
        title: "Job expiry duration (days)",
        description: "Receive notifications for new job applications",
        controlType: "input",
        inputConfig: { type: "number", width: 55, placeholder: "10", validate: false }
      },
      {
        id: 4,
        title: "Job code format",
        description: "Enable caching of job codes for better performance [Department]-[Role]-[Level]-[Number]",
        controlType: "input",
        inputConfig: { type: "text", width: 190, placeholder: " ", validate: false }
      }
    ]
  }
]

export type JobAdminSettingsResponse = {
  success: boolean;
  requestId: string;
  data: {
    module: string;
    settings: {
      code: {
        format?: string;
      };
      post: {
        requireApproval: boolean;
        defaultExpiryDays: number;
        autoUnpublishOnExpiry: boolean;
      };
    };
  };
};


export const getJobAdministratorSettings = () => ApiGet<JobAdminSettingsResponse>("/api/v1/settings/job-administrator");

export type JobAdminUpdateBody = {
  post?: {
    requireApproval?: boolean;
    defaultExpiryDays?: number;
    autoUnpublishOnExpiry?: boolean;
  };

  // backend supports only autoGenerate boolean (no format string)
  code?: {
    format?: string;
  };
};

//  adjust endpoint if yours is different
export const patchJobAdministratorSettings = (body: JobAdminUpdateBody) => ApiPatch("/api/v1/settings/job-administrator/update", body);